import { getSocketEnvelopeBody } from './partnerGroupChatSocketPayload';

const parseTemporaryDisableFlag = (value) => {
  if (value === true || value === 'true' || value === 1 || value === '1') return true;
  if (value === false || value === 'false' || value === 0 || value === '0') return false;
  return null;
};

export const parsePartnerTemporaryDisableSocket = (envelope = {}) => {
  const body = getSocketEnvelopeBody(envelope);
  const temporaryDisable = parseTemporaryDisableFlag(body.temporaryDisable);

  if (temporaryDisable == null) {
    return null;
  }

  return {
    partnerProfileId: body.partnerProfileId ?? body.id ?? null,
    temporaryDisable,
  };
};
